import CalculationsApi from 'api/calculations-api';
import {useMutation} from 'react-query';
import {saveEmailIllustrationsMutationKey} from 'constants/query';
import {statusToLoading} from 'adapter/loading.adapter';

export function useSaveEmailIllustrationsMutation() {
  const mutation = useMutation([saveEmailIllustrationsMutationKey], ({toEmails, calculationIds, attachments}) =>
    CalculationsApi.saveEmailIllustrations({
      toEmails: toEmails,
      calculationIds: calculationIds,
      attachments: attachments,
    }),
  );

  const loading = statusToLoading(mutation.status, mutation.isLoading);

  return {...mutation, loading};
}
